<template>
  <div class="newsletter-wrapper">
    <p class="medium light">Iscriviti alla nostra newsletter:</p>							
    <form id="nevs_form_iscrizione" class="newsletter" @submit.prevent="onSubmit" ref="form">
      <input class="newsletter-input" v-model="name" type="text" name="nome" placeholder="Nome" required>
      <input class="newsletter-input" v-model="surname" type="text" name="cognome" placeholder="Cognome" required>
      <input class="newsletter-input" v-model="email" type="email" name="email" placeholder="Indirizzo e-mail" required>

      <label class="control-checkbox">
        <input type="checkbox" name="privacy" id="privacy_consent" v-model="privacy"> 
        Autorizzo il trattamento dei dati secondo la nostra <router-link to="/privacy" target="_blank">privacy policy</router-link>.
        <div class="control-indicator"></div>
      </label>

      <input type="submit" id="newsletter-submit" class="button button-regular button-aqua button-anim" value="ISCRIVITI" :disabled="isDisabled">
    </form>
    <div id="nevs_response" ref="resp" :class="{visible: respIsVisible}"></div>
  </div>
</template>

<script>
import axios from 'axios/dist/axios';

export default {
  data() {
    return {
      respIsVisible: false,
      name: '',
      surname: '',
      email: '',
      privacy: false,
      isDisabled: true
    }
  },
  
  watch: {
    name: function(newVal, oldVal) {
      this.check();
    },
    surname: function(newVal, oldVal) {
      this.check();
    },
    email: function(newVal, oldVal) {
      this.check();
    },
    privacy: function(newVal, oldVal) {
      this.check();
    }
  },

  methods: {
    check: function() {
      if(this.name != '' && this.surname != '' && this.email != '' && this.privacy) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
    onSubmit: function(e) {
      e.stopPropagation();
      
      const data = {
        nome: this.name,
        cognome: this.surname,
        email: this.email
      };

      axios.post('/api/v1/user/newsletter', data)
        .then(resp => {
          if(resp.status == 200) {
            this.$refs.resp.innerHTML = 'La registrazione è avvenuta con successo';
            this.name = '';
            this.surname = '';
            this.email = '';
          } else {
            this.$refs.resp.innerHTML = 'Errore! Per favore, riprova!';
          }
          this.respIsVisible = true;
          setTimeout(() => this.respIsVisible = false, 4000);
        })
        .catch(err => {
          this.$refs.resp.innerHTML = 'Errore! Per favore, riprova!';
          this.respIsVisible = true;
          setTimeout(() => this.respIsVisible = false, 4000);
        });
    }
  }
}
</script>

<style scoped>
.control-checkbox .control-indicator::after {
  left: 5px;
  top: 1px;
}

#nevs_response {
  display: none;
}

#nevs_response.visible {
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/vue/components/FooterNewsletter.vue